import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { useTranslation } from 'react-i18next';
import VisuallyHidden from 'components/VisuallyHidden';
import { ContentCardButton } from 'components/ContentCards';
import shouldShowJoinMeetingLink from 'utils/shouldShowJoinMeetingLink';
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MeetingLink(_ref) {
  var eventSession = _ref.eventSession,
    assetName = _ref.assetName;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  var linkUrl = eventSession.linkUrl,
    status = eventSession.status,
    startDateTime = eventSession.startDateTime,
    endDateTime = eventSession.endDateTime;
  var showMeetingLink = shouldShowJoinMeetingLink({
    status: status,
    startDateTime: startDateTime,
    endDateTime: endDateTime,
    linkUrl: linkUrl
  });
  if (!showMeetingLink) {
    return null;
  }
  return /*#__PURE__*/_jsxs(ContentCardButton, {
    as: "a",
    href: "/api/url?url=".concat(encodeURIComponent(linkUrl || '')),
    target: "_blank",
    rel: "noopener noreferrer",
    icon: "external",
    children: [t('actions_join'), /*#__PURE__*/_jsxs(VisuallyHidden, {
      children: [" ", assetName]
    })]
  });
}
export default MeetingLink;